import { UPLOAD_FILE_V2_USE_CASE, UploadFileV2UseCase, GET_MANY_FILE_V2_USE_CASE, GetManyFileV2UseCase, DELETE_FILE_V2_USE_CASE, DeleteFileV2UseCase, CREATE_FILE_STORAGE_V2_USE_CASE, CreateFileStorageV2UseCase, FILE_STORAGE_V2_REPOSITORY, FILE_STORAGE_REPOSITORY, EXTERNAL_FILE_STORAGE_REPOSITORY, VALIDATE_PUBLIC_FILE_URL_USE_CASE, ValidatePublicFileUrlUseCase } from '../../../../file-storage';
export var fileManagementAppUseCaseProviders = [{
  provide: VALIDATE_PUBLIC_FILE_URL_USE_CASE,
  useFactory: function useFactory(fileStorageRepository) {
    return new ValidatePublicFileUrlUseCase(fileStorageRepository);
  },
  inject: [FILE_STORAGE_REPOSITORY]
}, {
  provide: UPLOAD_FILE_V2_USE_CASE,
  useFactory: function useFactory(externalFileStorageRepository) {
    return new UploadFileV2UseCase(externalFileStorageRepository);
  },
  inject: [EXTERNAL_FILE_STORAGE_REPOSITORY]
}, {
  provide: GET_MANY_FILE_V2_USE_CASE,
  useFactory: function useFactory(fileStorageV2Repository) {
    return new GetManyFileV2UseCase(fileStorageV2Repository);
  },
  inject: [FILE_STORAGE_V2_REPOSITORY]
}, {
  provide: DELETE_FILE_V2_USE_CASE,
  useFactory: function useFactory(fileStorageV2Repository) {
    return new DeleteFileV2UseCase(fileStorageV2Repository);
  },
  inject: [FILE_STORAGE_V2_REPOSITORY]
}, {
  provide: CREATE_FILE_STORAGE_V2_USE_CASE,
  useFactory: function useFactory(fileStorageV2Repository) {
    return new CreateFileStorageV2UseCase(fileStorageV2Repository);
  },
  inject: [FILE_STORAGE_V2_REPOSITORY]
}];